// Vida en Orden — helper de estado "VENCIDO" para gastos.
//
// Bug histórico: se comparaba `e.due_date` contra
// `new Date().toISOString().slice(0, 10)`, que devuelve la fecha en UTC.
// En Argentina (UTC-3), entre 21:00 y 23:59 hs locales, UTC ya avanzó al
// día siguiente, y por eso gastos con due_date == "hoy AR" se veían como
// VENCIDOS. La comparación DEBE hacerse como fecha calendario en la zona
// horaria America/Argentina/Buenos_Aires.
//
// `now` es inyectable exclusivamente para que los tests puedan fijar el
// instante actual — en runtime siempre se usa `new Date()`.

const AR_TZ = 'America/Argentina/Buenos_Aires';

function todayInAR(now = new Date()) {
  // en-CA formatea como "YYYY-MM-DD", compatible con `due_date` guardado.
  return now.toLocaleDateString('en-CA', { timeZone: AR_TZ });
}

function isOverdue(expense, now = new Date()) {
  if (!expense || expense.paid) return false;
  const due = expense.due_date;
  if (!due) return false;
  return String(due).slice(0, 10) < todayInAR(now);
}

module.exports = { todayInAR, isOverdue };
